import { defineField, defineType } from 'sanity'
import { commonBlockTypes } from '../pageBlocks'

export default defineType({
  title: 'Common Page Builder',
  name: 'commonPageBuilder',
  type: 'document',
  orderings: [
    {
      title: 'Title A-Z',
      name: 'titleAsc',
      by: [{field: 'title', direction: 'asc'}],
    },
  ],
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      description:
        'Title is not rendered on frontend. It is used for internal purposes only. You can search by title in Sanity Studio.',
    }),
    defineField({
      title: 'Blocks',
      name: 'blocks',
      type: 'array',
      of: [...commonBlockTypes],
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({ title }) {
      return {
        title,
        subtitle: 'Common Page Builder',
      }
    },
  },
})